import '@babel/polyfill'
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App'
import { createRouter } from './router'
import { createStore } from './store'

Vue.config.productionTip = false

/* eslint-disable no-new */
export function createApp () {
    // create router instance
    const router = createRouter()
    // create store instance
    const store = createStore()
    // sync routers state to store
    sync(store, router)
    // create vue instance
    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })

    return { app, router, store }
}



// WEBPACK FOOTER //
// ./src/main.js